/** Shared document-attach UI test ids. Wizard trigger variants keep historical string values. */
export const DOCUMENT_ATTACH_OWN_FILE_UPLOAD_SHELL_TEST_ID = 'guided-activity-wizard-own-file-upload-shell';
export const DOCUMENT_ATTACH_OWN_FILE_UPLOAD_DIALOG_TEST_ID = 'guided-activity-wizard-own-file-upload-dialog';
export const DOCUMENT_ATTACH_OWN_FILE_UPLOAD_CLOSE_TEST_ID = 'guided-activity-wizard-own-file-upload-close';
export const DOCUMENT_ATTACH_OWN_FILE_UPLOAD_INPUT_TEST_ID = 'guided-activity-wizard-own-file-upload-input';
export const DOCUMENT_ATTACH_OWN_FILE_UPLOAD_DONE_TEST_ID = 'guided-activity-wizard-own-file-upload-done';
export const DOCUMENT_ATTACH_OWN_FILE_UPLOAD_ERROR_TEST_ID = 'guided-activity-wizard-own-file-upload-error';

/**
 *
 * @returns The result of this operation.
 * @param index The Index value.
 */
export function documentAttachOwnFileUploadFailureTestId(index: number): string {
  return `guided-activity-wizard-own-file-upload-failure-${index}`;
}

/**
 *
 * @returns The result of this operation.
 * @param index The Index value.
 */
export function documentAttachOwnFileUploadFileTestId(index: number): string {
  return `guided-activity-wizard-own-file-upload-file-${index}`;
}

/**
 *
 * @returns The result of this operation.
 * @param index The Index value.
 */
export function documentAttachOwnFileUploadProgressTestId(index: number): string {
  return `guided-activity-wizard-own-file-upload-progress-${index}`;
}

/**
 *
 * @returns The result of this operation.
 * @param index The Index value.
 */
export function documentAttachOwnFileUploadRemoveTestId(index: number): string {
  return `guided-activity-wizard-own-file-upload-remove-${index}`;
}

export const DOCUMENT_ATTACH_LIBRARY_SHELL_TEST_ID = 'guided-activity-wizard-document-library-shell';
export const DOCUMENT_ATTACH_LIBRARY_DIALOG_TEST_ID = 'guided-activity-wizard-document-library-dialog';
export const DOCUMENT_ATTACH_LIBRARY_CLOSE_TEST_ID = 'guided-activity-wizard-document-library-close';
export const DOCUMENT_ATTACH_LIBRARY_DONE_TEST_ID = 'guided-activity-wizard-document-library-done';
export const DOCUMENT_ATTACH_LIBRARY_EMPTY_FILTERED_TEST_ID = 'guided-activity-wizard-document-library-empty-filtered';
export const DOCUMENT_ATTACH_LIBRARY_EMPTY_TEST_ID = 'guided-activity-wizard-document-library-empty';
export const DOCUMENT_ATTACH_LIBRARY_ERROR_DELETE_TEST_ID = 'guided-activity-wizard-document-library-error-delete';
export const DOCUMENT_ATTACH_LIBRARY_ERROR_TEST_ID = 'guided-activity-wizard-document-library-error';
export const DOCUMENT_ATTACH_LIBRARY_ERROR_USAGE_TEST_ID = 'guided-activity-wizard-document-library-error-usage';
export const DOCUMENT_ATTACH_LIBRARY_LOADING_TEST_ID = 'guided-activity-wizard-document-library-loading';
export const DOCUMENT_ATTACH_LIBRARY_PAGINATION_TEST_ID = 'guided-activity-wizard-document-library-pagination';
export const DOCUMENT_ATTACH_LIBRARY_SEARCH_TEST_ID = 'guided-activity-wizard-document-library-search';
export const DOCUMENT_ATTACH_LIBRARY_SELECTED_COUNT_TEST_ID = 'guided-activity-wizard-document-library-selected-count';
export const DOCUMENT_ATTACH_LIBRARY_TABLE_TEST_ID = 'guided-activity-wizard-document-library-table';

/**
 *
 * @returns The result of this operation.
 * @param documentId The Document id value.
 */
export function documentAttachLibraryDeleteTestId(documentId: string): string {
  return `guided-activity-wizard-document-library-delete-${documentId}`;
}

/**
 *
 * @returns The result of this operation.
 * @param index The Index value.
 */
export function documentAttachLibraryRowTestId(index: number): string {
  return `guided-activity-wizard-document-library-row-${index}`;
}

/**
 *
 * @returns The result of this operation.
 * @param fileType The File type value.
 */
export function documentAttachLibraryTypeFilterTestId(fileType: string): string {
  return `guided-activity-wizard-document-library-type-filter-${fileType}`;
}

export const DOCUMENT_ATTACH_DELETE_CONFIRM_DIALOG_TEST_ID = 'guided-activity-wizard-document-delete-confirm-dialog';

export const DOCUMENT_ATTACH_COMPOSER_MENU_TRIGGER_TEST_ID = 'guided-activity-wizard-attach-menu-trigger';
export const DOCUMENT_ATTACH_COMPOSER_OWN_FILE_TEST_ID = 'guided-activity-wizard-attach-own-file';
export const DOCUMENT_ATTACH_COMPOSER_FROM_LIBRARY_TEST_ID = 'guided-activity-wizard-attach-from-library';

export const DOCUMENT_ATTACH_SIDEBAR_MENU_TRIGGER_TEST_ID =
  'guided-activity-wizard-planning-assistant-documents-attach-menu-trigger';
export const DOCUMENT_ATTACH_SIDEBAR_OWN_FILE_TEST_ID =
  'guided-activity-wizard-planning-assistant-documents-attach-own-file';
export const DOCUMENT_ATTACH_SIDEBAR_FROM_LIBRARY_TEST_ID =
  'guided-activity-wizard-planning-assistant-documents-attach-from-library';

export const DOCUMENT_ATTACH_REVIEW_MENU_TRIGGER_TEST_ID =
  'guided-activity-wizard-review-documents-attach-menu-trigger';
export const DOCUMENT_ATTACH_REVIEW_OWN_FILE_TEST_ID = 'guided-activity-wizard-review-documents-attach-own-file';
export const DOCUMENT_ATTACH_REVIEW_FROM_LIBRARY_TEST_ID =
  'guided-activity-wizard-review-documents-attach-from-library';

export const DOCUMENT_ATTACH_PROMPT_MENU_TRIGGER_TEST_ID = 'similar-activity-prompt-attach-menu-trigger';
export const DOCUMENT_ATTACH_PROMPT_OWN_FILE_TEST_ID = 'similar-activity-prompt-attach-own-file';
export const DOCUMENT_ATTACH_PROMPT_FROM_LIBRARY_TEST_ID = 'similar-activity-prompt-attach-from-library';
